export const trackServiceDetailsModalOpen = (service: string): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    // external_service_modal_open
    window.gtag('event', 'service_details_modal_open', {
      event_category: 'Modal open',
      event_label: service,
      value: 1,
    });
  }
};
